import React from 'react';

import { DESKTOP, MOBILE } from '../../../constants/breakpoints';

import _ from 'lodash';
import cx from 'classnames';

import { useActionExectioner } from '../core/actions';

import Fonts from '../../fonts/';
import { AnimationComponent } from '../../Animations';

import styles from './text.module.scss';

const TextWidgetComponent = ({className, style, widgetProps, breakpoint}) => {
  const elementRef = React.useRef(null);
  const actionExcutioner = useActionExectioner();

  const id = _.get(widgetProps, 'uid');
  const content = _.get(widgetProps, 'content');
  const actions = _.get(widgetProps, 'actions');

  const fontSize = _.get(widgetProps, `properties.${breakpoint}.fontSize`);
  const mobileFontSize = _.get(widgetProps, `properties.${MOBILE}.fontSize`);
  const desktopFontSize = _.get(widgetProps, `properties.${DESKTOP}.fontSize`);

  const fontAlignment = _.get(widgetProps, `properties.${breakpoint}.alignment`);
  const textAimation = _.get(widgetProps, `properties.${breakpoint}.animation`) || {};
  const lineSpacing = _.get(widgetProps, `properties.${breakpoint}.lineSpacing`);
  const letterSpacing = _.get(widgetProps, `properties.${breakpoint}.letterSpacing`);

  Fonts.useFont(_.get(widgetProps, 'fonts') || []);

  React.useEffect(() => {
    if(elementRef.current){
      elementRef.current.addEventListener('click', handleClickEvent);
    }

    return () => {
      if(elementRef.current){
        elementRef.current.removeEventListener('click', handleClickEvent);
      }
    }
  }, [actionExcutioner]);

  var widgetStyle = {
    ...style,
    textAlign: fontAlignment,
    lineHeight: `${lineSpacing}`,
    letterSpacing: `${fontSize * letterSpacing}px`
  }

  const processChildNodes = (node, ratio) => {
    if(!node || node.nodeType != 1){
      return;
    }

    var fontValue = node.style.fontSize;
    if(fontValue){
      fontValue = parseFloat(fontValue);
      var newValue = fontValue * ratio;
      newValue = Math.max(13, newValue);
      node.style.fontSize = `${newValue}px`;
    }

    Array.from(node.children).forEach(child => {
      processChildNodes(child, ratio);
    });
  }

  const processedContent = React.useMemo(() => {
    if(breakpoint === DESKTOP){
      return content;
    }

    //Calculate Font sizes for mobile
    var root = document.createElement('div');
    root.innerHTML = (content || "").trim();

    const ratio = mobileFontSize / desktopFontSize;

    Array.from(root.children).forEach(child => {
      child.style.fontSize = `${mobileFontSize}px`;

      Array.from(child.children).forEach(childNode => {
        processChildNodes(childNode, ratio);
      });
    });

    return root.innerHTML;
  }, [content, breakpoint]);


  const handleClickEvent = (e) => {
    const target = e.target;
    const anchor = target.closest(`.${styles.text} a`);
    if(!anchor){
      return;
    }

    const actionId = anchor.dataset.action;
    const action = actionId && actions.find(item => item.uid === actionId);
    if(action){
      e.preventDefault();
      e.stopPropagation();

      actionExcutioner.execute(widgetProps, action);
    }
  }

  return (
    <div id={id}
      ref={elementRef}
      className={cx(className, styles.text, 'cs_text_widget')}
      style={widgetStyle}
      data-widget-id={id}
    >
      <AnimationComponent {...textAimation}>
        <div dangerouslySetInnerHTML={{__html: processedContent}}/>
      </AnimationComponent>
    </div>
  );
}

const textWidgetEquals = function(prevProps, nextProps){
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps,paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const TextWidget = React.memo(TextWidgetComponent, textWidgetEquals);